import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App.jsx';
import Login from './components/Login/Login.jsx';

import './index.css';
import './fonts/icomoon.css';
import {IntlProvider} from 'react-intl';
import { Router, Route, hashHistory} from 'react-router';


ReactDOM.render(
  <IntlProvider locale="en">
    <Router history={hashHistory}>
      <Route path="/login" component={Login}/>
      <Route path="*" component={App}/>
    </Router>
  </IntlProvider>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/